// extracted by mini-css-extract-plugin
export default {"content":"Team_content__TvBY8","title":"Team_title__CcsUB","tag":"Team_tag__Veeh2","container":"Team_container__5igmY","card":"Team_card__moD56"};